import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Layout,
  Menu,
  Button,
  Drawer,
  message,
  Spin,
  Flex,
  Tooltip,
} from "antd";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { logOut } from "../Service/logout";
import { useSessionRefresh } from "./useSessionRefresh";
import Sider from "antd/es/layout/Sider";
import {
  MdCategory,
  MdDashboardCustomize,
  MdEngineering,
  MdLogout,
  MdNotificationsActive,
  MdOutlineMonitorHeart,
  MdPrecisionManufacturing,
} from "react-icons/md";
import { BiSolidUserCircle } from "react-icons/bi";
import {
  TbChecklist,
  TbHeartRateMonitor,
  TbRulerMeasure,
} from "react-icons/tb";
import { FcComboChart } from "react-icons/fc";
import { IoSettingsOutline } from "react-icons/io5";
import { GiFactory } from "react-icons/gi";
import { FaUserCheck, FaUserCircle } from "react-icons/fa";
import { LiaSitemapSolid } from "react-icons/lia";
import { PiPulseFill } from "react-icons/pi";
import { SiZigbee2Mqtt } from "react-icons/si";

const { Header, Content } = Layout;

const HomePage = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState(null);

  const toggleDrawer = () => {
    setOpen(!open);
  };
  const logout = () => {
    setIsLoading(true);

    logOut()
      .then((res) => {})
      .catch((err) => {
        console.log("err", err);
        messageApi.open({
          type: "error",
          content: err.message || err.response.data?.message,
        });
      })
      .finally(() => {
        Cookies.remove("user_details");
        // Cookies.remove("AUTH_TOKEN");
        // Cookies.remove("REFRESH_TOKEN");
        navigate("/login", { replace: true });
        setIsLoading(false);
      });
  };
  useEffect(() => {
    const details = Cookies.get("user_details");
    if (details) {
      try {
        setUserDetails(JSON.parse(details));
      } catch (e) {
        setUserDetails(null);
      }
    }
  }, []);

  // Function to refresh the token expiration on user activity
  useSessionRefresh();

  const menuItems = [
    {
      key: "/",
      icon: <FcComboChart />,
      label: "Dashboard",
    },
    {
      key: "check-list-builder",
      icon: <TbChecklist />,
      label: "Checklist Builder",
      children: [
        {
          key: "check-list-builder/check-list",
          icon: <TbChecklist />,
          label: "Checklist",
        },
        {
          key: "check-list-builder/configuration",
          icon: <IoSettingsOutline />,
          label: "Configuration",
          children: [
            {
              key: "check-list-builder/configuration",
              icon: <MdCategory />,
              label: "Category",
            },
            {
              key: "check-list-builder/configuration/checklist-builder",
              icon: <MdDashboardCustomize />,
              label: "Templates",
            },
          ],
        },
      ],
    },
    {
      key: "quality",
      icon: <TbRulerMeasure />,
      label: "Quality Plan",
      children: [
        {
          key: "quality/procedure",
          icon: <TbChecklist />,
          label: "Execution",
        },
        {
          key: "quality/configuration",
          icon: <IoSettingsOutline />,
          label: "Configuration",
          children: [
            {
              key: "quality/configuration",
              icon: <MdCategory />,
              label: "Device Type",
            },
            {
              key: "quality/configuration/procedure-builder",
              icon: <MdDashboardCustomize />,
              label: "Templates",
            },
          ],
        },
      ],
    },
    {
      key: "ams",
      icon: <MdOutlineMonitorHeart />,
      label: "Asset Monitoring System",
      children: [
        {
          key: "ams/live-monitoring",
          icon: <PiPulseFill />,
          label: "Live Monitoring",
        },
        {
          key: "ams/notifications",
          icon: <MdNotificationsActive />,
          label: "Notifications",
        },
      ],
    },
  ];

  if (
    userDetails &&
    (userDetails.roles === "Supervisor" ||
      userDetails.roles === "ROLE_OPERATOR" ||
      userDetails.roles === "Admin" ||
      userDetails.roles === "ROLE_SUPER_ADMIN" ||
      true)
  ) {
    menuItems.push({
      key: "configuration",
      icon: <IoSettingsOutline />,
      label: "Configuration",
      children: [
        {
          key: "configuration",
          icon: <GiFactory />,
          label: "Organization",
        },
        {
          key: "configuration/product",
          icon: <LiaSitemapSolid />,
          label: "Product",
        },
        {
          key: "configuration/iot-gateway",
          icon: <SiZigbee2Mqtt />,
          label: "IOT Gateway",
        },
        {
          key: "configuration/machine",
          icon: <MdPrecisionManufacturing />,
          label: "Machine",
        },
        {
          key: "configuration/role",
          icon: <MdEngineering />,
          label: "Role",
        },
        {
          key: "configuration/user",
          icon: <FaUserCircle />,
          label: "User",
        },
        {
          key: "configuration/user-access",
          icon: <FaUserCheck />,
          label: "User Access",
        },
      ],
    });
  }
  const isLoggedIn = Cookies.get("user_details");
  return isLoggedIn ? (
    <Spin spinning={isLoading}>
      {contextHolder}
      <Layout style={{ height: "100vh" }}>
        <Layout>
          <Sider
            style={{
              background: "white",
              overflow: "auto",
              height: "100vh",
              position: "sticky",
              insetInlineStart: 0,
              top: 0,
              bottom: 0,
              scrollbarWidth: "none",
              scrollbarGutter: "stable",
              overflow: "hidden",
            }}
            collapsible
            collapsed={!open}
            onCollapse={toggleDrawer}
            width={250}
            trigger={null} // disable default trigger, we’ll add our own
          >
            <Button
              type="text"
              block
              onClick={toggleDrawer}
              style={{ margin: "15px 0px" }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/step_to_innovation_logo.jpeg`}
                alt="Logo"
                style={{
                  width: "3rem",
                  height: "auto",
                  borderRadius: "50%",
                  // marginRight: "10px",
                }}
              />
              {open && <h3>Step to Innovation</h3>}
            </Button>
            <Menu
              mode="inline"
              onClick={({ key }) => {
                navigate(key);
                // setOpen(false);
              }}
              style={{
                overflowY: "auto",
                height: "calc(100vh - 170px)",
                scrollbarWidth: "none",
              }}
              items={menuItems}
            />

            <div
              style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                background: "white",
                padding: "10px",
                borderTop: "1px solid #f0f0f0",
                textAlign: "center",
              }}
            >
              <Flex
                align="center"
                justify={open ? "flex-start" : "center"}
                style={{ marginBottom: "8px" }}
              >
                {open ? (
                  <>
                    <BiSolidUserCircle
                      style={{
                        fontSize: "40px",
                        marginRight: "10px",
                        color: "gray",
                      }}
                    />
                    <div style={{ textAlign: "start" }}>
                      <div>{userDetails?.name || "User Name"}</div>
                      <small style={{ color: "gray" }}>
                        {userDetails?.roles || "User Role"}
                      </small>
                    </div>
                  </>
                ) : (
                  <Tooltip
                    title={
                      <div style={{ textAlign: "start" }}>
                        <div>{userDetails?.userName || "User Name"}</div>
                        <small>{userDetails?.role || "User Role"}</small>
                      </div>
                    }
                    placement="right"
                  >
                    <BiSolidUserCircle
                      style={{
                        fontSize: "40px",
                        color: "gray",
                      }}
                    />
                  </Tooltip>
                )}
              </Flex>

              <Button
                type="text"
                block
                onClick={logout}
                style={{
                  display: "flex",
                  alignItems: "center",
                  // justifyContent: open ? "flex-start" : "center",
                  justifyContent: "center",
                  gap: open ? "8px" : "0px",
                }}
              >
                <MdLogout /> {open && "Logout"}
              </Button>
            </div>
          </Sider>

          {/* Main content */}
          <Content
            style={{
              margin: "16px",
              padding: 16,
              overflow: "auto",
              // background: "#fff",
              scrollbarWidth: "none",
              scrollbarGutter: "stable",
              borderRadius: "10px",
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Spin>
  ) : (
    <Navigate to="/login" />
  );
};

export default HomePage;
